export const AGENT_V2_DRAFT_KEY = "waajo.agentAiV2.wizardDraft.v1";
export const AGENT_V2_DRAFT_VERSION = 1;

export function serializeWizardDraft(data) {
  return JSON.stringify(
    Object.assign(
      {
        version: AGENT_V2_DRAFT_VERSION,
        savedAt: Date.now()
      },
      data
    )
  );
}

export function parseWizardDraft(raw) {
  if (!raw) return null;
  let draft;
  try {
    draft = JSON.parse(raw);
  } catch (error) {
    return null;
  }
  if (!draft || Number(draft.version) !== AGENT_V2_DRAFT_VERSION) return null;
  if (!draft.licenseId || typeof draft.licenseId !== "string") return null;
  if (draft.mode !== "always" && draft.mode !== "schedule") return null;
  if (!draft.forms || !draft.forms.always || !draft.forms.working || !draft.forms.away) {
    return null;
  }
  const step = Number(draft.step);
  return {
    version: AGENT_V2_DRAFT_VERSION,
    savedAt: Number(draft.savedAt) || 0,
    licenseId: draft.licenseId,
    configId: draft.configId == null ? "" : String(draft.configId),
    mode: draft.mode,
    step: step >= 1 && step <= 5 ? step : 2,
    forms: draft.forms
  };
}



// WEBPACK FOOTER //
// ./src/views/ai/agentV2/wizardDraft.js